module.exports = __webpack_public_path__ + "img/CloudKitch_logo_solo.7553e5d9.png";